
<div class="modal fade" id="{{loadsStatusModalId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">

            <div class="modal-header">
                <h6 class="modal-title">Loads Status</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close" *ngIf="parentComponent=='schedules'"></button>
                <button type="button" class="btn-close btn-sm" attr.data-bs-target="#{{parentComponent}}" data-bs-toggle="modal" aria-label="Close" *ngIf="parentComponent!='schedules'"></button>
            </div>
            <div class="modal-body">

                <div class="container-fluid">
                    <!--<div class="row mb-2">
                        <div class="col-12">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="failedOnly" name="failedOnly" (change)="filterLoads()" [(ngModel)]="failedOnly">
                                <label class="form-check-label form-label" for="failedOnly">Show Failed Only</label>
                            </div>
                        </div>
                    </div>-->

                    <div class="border border-rounded px-1 mb-2 table-responsive" style="height: 600px;">
                        <table class="table table-sm table-borderless table-striped scrollable">
                            <thead>
                                <tr>
                                    <th>Load&nbsp;ID</th>
                                    <th>Commodity</th>
                                    <th>Carrier</th>
                                    <th>Load&nbsp;#</th>
                                    <th>Unload&nbsp;#</th>
                                    <th>Status</th>
                                    <th>Load&nbsp;Date</th>
                                    <th>Unload&nbsp;Date</th>
                                    <th>Rate</th>
                                    <th>UOM</th>
                                    <th>Contact</th>
                                    <th>Origin</th>
                                    <th>Destination</th>
                                    <th>Bus&nbsp;Unit</th>
                                    <th>Comm</th>
                                    <th>Sales</th>
                                    <th>Purchase</th>
                                    <th>Response</th>
                                    <th>UUID</th>
                                    <th>Reason</th>
                                    <th>Req&nbsp;Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let load of filteredLoadList">
                                    <td>{{load.loadId}}</td>
                                    <td>{{load.commodityName}}</td>
                                    <td>{{load.carrierReference}}</td>
                                    <td>{{load.loadNumber}}</td>
                                    <td>{{load.unloadNumber}}</td>
                                    <td>{{load.loadStatus}}</td>
                                    <td>{{load.loadDate}}</td>
                                    <td>{{load.unloadDate}}</td>
                                    <td>{{load.rate}}</td>
                                    <td>{{load.rateUnitOfMeasure}}</td>
                                    <td>{{load.contactName}}</td>
                                    <td>{{load.origin}}</td>
                                    <td>{{load.destination}}</td>
                                    <td>{{load.businessUnit}}</td>
                                    <td>{{load.shipperCommodity}}</td>
                                    <td>{{load.saleCustomer}}<br />{{load.saleContract}}</td>
                                    <td>{{load.purchaseCustomer}}<br />{{load.purchaseContract}}</td>
                                    <td>{{load.responseStatus}}</td>
                                    <td>{{load.rogerUuid}}</td>
                                    <td>{{load.errorReason}}</td>
                                    <td>{{load.requestType}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





